var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgImageIcon75X75(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Image-icon-75x75",
    xmlns: "http://www.w3.org/2000/svg",
    width: 76.44,
    height: 76.44,
    viewBox: "0 0 76.44 76.44",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_22",
    "data-name": "Rectangle 22",
    width: 75,
    height: 75,
    rx: 6.04,
    transform: "translate(0.72 0.72)",
    fill: "#fff",
    stroke: "#e6e6e6",
    strokeMiterlimit: 22.926,
    strokeWidth: 1.44
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "_59268016",
    transform: "translate(8.605 15.042)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_23",
    "data-name": "Rectangle 23",
    width: 59.229,
    height: 46.346,
    rx: 4.2,
    fill: "#a2d9f7"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    "data-name": "Group 2",
    transform: "translate(12.788 5.769)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_31",
    "data-name": "Path 31",
    d: "M30.768,31.067c-.6.325-.365,0-.818.8-.2.355-.384.789-.572,1.153-.384.769-.779,1.538-1.163,2.3l-4.662,9.147c-3.371,6.673-3.509,5.5,11.345,5.5H48.727c1.321,0,5.53.631,5.5-1.035-.01-.67-4.82-7.442-5.5-8.28C45.583,36.774,44,46.335,40.3,41.782l-7.491-9.788c-.444-.611-.956-1.508-2.04-.917Z",
    transform: "translate(-21.694 -21.243)",
    fill: "#fff",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_32",
    "data-name": "Path 32",
    d: "M43.138,21.3c-6.407,1.912-3.371,10.7,2.435,9.058a4.7,4.7,0,0,0,3.263-5.825,4.609,4.609,0,0,0-5.7-3.233Z",
    transform: "translate(-21.95 -21.102)",
    fill: "#ff0",
    fillRule: "evenodd"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageIcon75X75);
export default __webpack_public_path__ + "static/media/Image-icon-75x75.28ef67f2657cfa05bdc166707e7d23a7.svg";
export { ForwardRef as ReactComponent };